import { createRoot } from "react-dom/client";

export function mount(component) {
  const element = document.createElement("div");
  element.setAttribute("id", "main-mount");
  document.body.appendChild(element);
  const container = document.getElementById("main-mount");
  const root = createRoot(container);
  root.render(component);
}
